import React, { useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col, Row, Form, Card, Button, Container, InputGroup, Spinner
} from '@themesberg/react-bootstrap';
import { BASE_URL } from '../../constants';

const Signin = () => {
  const [email, setEmail] = useState('');
  const [identifiant, setIdentifiant] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showResend, setShowResend] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleForgotPassword = () => {
    navigate('/forget-psw');
  };

  const handleResendVerification = async () => {
    if (!email) {
      setError('Please enter your email before resending the verification link.');
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/users/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      if (response.ok) {
        setError('Verification email sent. Please check your inbox.');
        setShowResend(false);
      } else {
        setError(data.msg || 'Failed to resend verification email.');
      }
    } catch (err) {
      setError('Server Error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setShowResend(false);

    try {
      const response = await fetch(`${BASE_URL}/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email || undefined,
          identifiant: identifiant || undefined,
          password
        })
      });

      const data = await response.json();
      setLoading(false);

      if (!response.ok) {
        if (data.message?.includes('activate your account')) {
          setError('Your account is not verified. Please check your email.');
          setShowResend(true);
        } else if (data.message?.toLowerCase().includes('invalid email')) {
          setError('User not found. Invalid email or username');
        } else if (data.message?.toLowerCase().includes('invalid password')) {
          setError('Incorrect password. Please try again.');
        } else {
          setError(data.msg || 'Invalid email or password.');
        }
        return;
      }
    
      login(data.userData);
      localStorage.setItem('token', data.token);
      navigate('/');
    } catch (err) {
      setLoading(false);
      setError('Server Error. Please try again later.');
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <p className="text-center">
            <Card.Link as={Link} to="/" className="text-gray-700">
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to homepage
            </Card.Link>
          </p>
          <Row className="justify-content-center form-bg-image">
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center mb-4">
                  <h3>Sign In to your Account</h3>
                </div>
                <Form onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Your Email Or User_Id</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        placeholder="Email or User ID"
                        value={email || identifiant}
                        onChange={(e) => {
                          const value = e.target.value.trim();
                          if (value.includes('@')) {
                            setEmail(value);
                            setIdentifiant('');
                          } else {
                            setIdentifiant(value);
                            setEmail('');
                          }
                        }}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Your Password</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Card.Link className="small text-end" onClick={handleForgotPassword}>
                    Forget your Password?
                  </Card.Link>

                  <div className="text-center">
                    <Button type="submit" className="w-100 mt-3" disabled={loading}>
                      {loading ? <Spinner animation="border" size="sm" /> : 'Sign In'}
                    </Button>
                    {error && <p className="text-danger mt-2">{error}</p>}
                    {showResend && (
                      <Button className="fw-normal" variant="link" onClick={handleResendVerification}>
                       Send Verification Email
                      </Button>
                    )}
                  </div>
                </Form>

                <div className="d-flex justify-content-center align-items-center mt-4">
                 {/**  <span className="fw-normal">
                    Don't have an account?
                    <Card.Link as={Link} to="/register" className="fw-bold">
                      {` Create account `}
                    </Card.Link>
                  </span>*/}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Signin;
